import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { getMarketmakingOrderTable } from "../../../Requests/marketmaking";
import {
  IMarketmakingOrderTableReport,
  IMarketmakingOrderTableSearchParams,
} from "../../../Interfaces/marketmaking";
import { MarketmakingOrderTableAdditional } from "./Additional";

interface IProps {
  searchParam: IMarketmakingOrderTableSearchParams;
}

const MarketmakingOrderTable = ({ searchParam }: IProps) => {
  return (
    <div className="overflow-auto order-table w-full">
      <TableTemplate<
        IMarketmakingOrderTableSearchParams,
        IMarketmakingOrderTableReport
      >
        refreshTableTime={5000}
        withSort
        getDataTable={getMarketmakingOrderTable}
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            AdditionalBody={MarketmakingOrderTableAdditional}
            tableBoxClassName="max-h-[300px]"
            withSelect
          />
        )}
        searchParameters={searchParam}
        showIsLoading={false}
      />
    </div>
  );
};

export default MarketmakingOrderTable;
